import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { APP_PROPERTIES } from './app/app-properties.model';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

bootstrapApplication(App, {
  ...appConfig,
  providers: [{ provide: APP_PROPERTIES, useValue: environment.properties }, ...appConfig.providers],
}).catch((reason: unknown) => {
  document.dispatchEvent(new CustomEvent('apperror', { bubbles: true, detail: reason }));
});
